import { TutorialStep, PageTutorialConfig } from '../types';

// Header steps for prestataire context
export const prestataireHeaderSteps: TutorialStep[] = [
  {
    target: '[data-onboarding="sidebar-trigger"]',
    title: "Menu latéral",
    message: "Accédez à vos missions, votre calendrier, votre profil et toutes vos fonctionnalités",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="home-button"]',
    title: "Tableau de bord",
    message: "Retournez à votre tableau de bord pour voir vos missions et statistiques",
    position: "bottom"
  },
  {
    target: '[data-onboarding="back-button"]',
    title: "Retour",
    message: "Revenez à la page précédente",
    position: "bottom"
  },
  {
    target: '[data-onboarding="role-badge"]',
    title: "Votre rôle",
    message: "Ce badge indique que vous êtes connecté en tant que Prestataire",
    position: "bottom"
  },
  {
    target: '[data-onboarding="language-selector"]',
    title: "Langue",
    message: "Changez la langue de l'interface selon vos préférences",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="logout-button"]',
    title: "Déconnexion",
    message: "Déconnectez-vous de votre espace prestataire",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="help-button"]',
    title: "Aide",
    message: "Cliquez ici à tout moment pour revoir ce tutoriel",
    position: "bottom-left"
  },
  // Sidebar steps prestataire
  {
    target: '[data-onboarding="sidebar-presta-dashboard"]',
    title: "Mon Dashboard",
    message: "Accédez à votre tableau de bord avec vos statistiques et activités",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-presta-infos"]',
    title: "Mes Infos",
    message: "Gérez vos informations personnelles et professionnelles",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-presta-competences"]',
    title: "Mes Compétences",
    message: "Déclarez et gérez vos compétences pour recevoir des missions adaptées",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-presta-missions"]',
    title: "Missions",
    message: "Consultez les missions proposées et acceptées",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-presta-calendrier"]',
    title: "Calendrier",
    message: "Gérez vos disponibilités et planifiez vos interventions",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-presta-estimation"]',
    title: "Estimation IA",
    message: "Utilisez l'IA pour créer des estimations de prix pour vos clients",
    position: "bottom-right"
  }
];

// Page-specific tutorials for prestataire pages
export const prestatairePageConfigs: PageTutorialConfig[] = [
  {
    routePattern: "/dashboard-prestataire",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="presta-help-navigation"]',
        title: "Aide à la navigation",
        message: "Ce bloc vous rappelle comment accéder au menu latéral pour naviguer dans votre espace.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-competences-card"]',
        title: "Vos compétences",
        message: "Visualisez et gérez vos compétences déclarées. Plus vous en avez, plus vous recevrez de missions.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-competences-btn"]',
        title: "Gérer les compétences",
        message: "Cliquez ici pour ajouter, modifier ou supprimer vos compétences.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="presta-stats-grid"]',
        title: "Vos statistiques",
        message: "Suivez vos missions disponibles, votre profil, abonnement et tickets support.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-missions-card"]',
        title: "Missions disponibles",
        message: "Nombre de missions dans votre zone correspondant à vos compétences.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-profile-status"]',
        title: "Statut du profil",
        message: "Votre pourcentage de complétion de profil. Un profil complet reçoit plus de missions.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-abonnement-card"]',
        title: "Abonnement",
        message: "Votre formule d'abonnement actuelle et sa date d'expiration.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-support-card"]',
        title: "Support",
        message: "Vos tickets de support en cours. Contactez-nous en cas de problème.",
        position: "bottom-left"
      }
    ]
  },
  {
    routePattern: "/prestataire/dashboard",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="presta-help-navigation"]',
        title: "Aide à la navigation",
        message: "Ce bloc vous rappelle comment accéder au menu latéral.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/mes-infos",
    exactMatch: true,
    steps: [
      // Introduction
      {
        target: '[data-onboarding="presta-mesinfos-intro"]',
        title: "Bienvenue dans Mes Informations",
        message: "Cette page vous permet de compléter votre profil prestataire. Un profil complet augmente vos chances de recevoir des missions. Suivez ce guide pour remplir chaque section.",
        position: "bottom"
      },
      // Section Identité
      {
        target: '[data-onboarding="presta-identity-section"]',
        title: "Section Mon Identité",
        message: "Cette section contient vos informations personnelles légales. Elles apparaîtront sur vos factures et documents officiels. Remplissez-les avec soin.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-identity-photo"]',
        title: "Photo d'identité",
        message: "Ajoutez une photo format passeport. Elle permet aux clients de vous identifier lors des interventions. Utilisez une photo professionnelle et récente (max 5 Mo).",
        position: "bottom-right"
      },
      {
        target: '[data-onboarding="presta-identity-lastname"]',
        title: "Votre nom de famille",
        message: "Saisissez votre nom de famille tel qu'il apparaît sur vos documents officiels. Ce champ est obligatoire.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-identity-firstname"]',
        title: "Votre prénom",
        message: "Saisissez votre prénom. Il sera affiché aux clients lorsqu'ils consulteront votre profil.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-identity-email"]',
        title: "Adresse email",
        message: "Votre email de contact professionnel. Nous l'utiliserons pour vous envoyer des notifications de missions et des informations importantes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-identity-phone"]',
        title: "Numéro de téléphone",
        message: "Ce numéro est lié à votre compte et ne peut pas être modifié pour des raisons de sécurité. Contactez le support si vous devez le changer.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-identity-address"]',
        title: "Adresse complète",
        message: "Votre adresse professionnelle. Elle est utilisée pour calculer votre zone d'intervention et vous proposer des missions à proximité. Les coordonnées GPS sont automatiquement récupérées.",
        position: "bottom"
      },
      // Section Réseaux Sociaux
      {
        target: '[data-onboarding="presta-social-section"]',
        title: "Réseaux Sociaux (optionnel)",
        message: "Ajoutez vos profils sur les réseaux sociaux pour améliorer votre visibilité. Les clients pourront vous retrouver plus facilement. Cette section est entièrement optionnelle.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-social-whatsapp"]',
        title: "WhatsApp",
        message: "Si vous utilisez WhatsApp professionnellement, ajoutez votre numéro. Certains clients préfèrent ce mode de communication.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-social-linkedin"]',
        title: "LinkedIn",
        message: "Votre profil LinkedIn professionnel. Utile pour montrer votre parcours et expérience aux clients.",
        position: "bottom"
      },
      // Section Profil Pro/Particulier
      {
        target: '[data-onboarding="presta-profile-type-section"]',
        title: "Type de profil",
        message: "Indiquez si vous êtes un professionnel (avec KBIS) ou un particulier. Ce choix détermine les documents requis et les obligations légales qui s'appliquent à vous.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-profile-checkbox"]',
        title: "Statut professionnel",
        message: "Cochez cette case si vous êtes une entreprise, auto-entrepreneur ou association avec un KBIS. Cela débloquera les sections d'informations d'entreprise et de documents obligatoires.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-particulier-warning"]',
        title: "Informations pour les particuliers",
        message: "Si vous n'êtes pas professionnel, lisez attentivement ces informations sur vos obligations fiscales, les plafonds légaux et les types de travaux autorisés.",
        position: "bottom"
      },
      // Section Entreprise (si pro)
      {
        target: '[data-onboarding="presta-company-section"]',
        title: "Informations d'entreprise",
        message: "Cette section apparaît uniquement pour les professionnels. Renseignez les informations légales de votre entreprise.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-company-name"]',
        title: "Nom de la société",
        message: "Le nom officiel de votre entreprise tel qu'il figure sur votre KBIS. Il apparaîtra sur les devis et factures.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-company-logo"]',
        title: "Logo de l'entreprise",
        message: "Téléchargez le logo de votre entreprise. Il sera affiché sur votre profil public et vos documents.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-company-siret"]',
        title: "Numéro SIRET",
        message: "Votre numéro SIRET à 14 chiffres. Il permet de vérifier l'existence légale de votre entreprise et est obligatoire pour les professionnels.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-company-apenaf"]',
        title: "Code APE/NAF",
        message: "Le code APE (ou NAF) identifie votre activité principale. Il figure sur votre avis de situation INSEE.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-company-website"]',
        title: "Site web",
        message: "L'URL de votre site internet professionnel (optionnel). Permet aux clients de découvrir vos réalisations.",
        position: "bottom"
      },
      // Section Documents
      {
        target: '[data-onboarding="presta-documents-section"]',
        title: "Documents d'entreprise",
        message: "Téléversez vos documents obligatoires : extrait KBIS et attestation de Responsabilité Civile Professionnelle (RCP). Ils seront vérifiés automatiquement par notre IA.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-documents-upload"]',
        title: "Zone de téléchargement",
        message: "Cliquez ou glissez vos fichiers ici. Vous pouvez télécharger plusieurs documents simultanément. Formats acceptés : PDF, JPG, PNG. Tous les documents sont sécurisés par filigrane.",
        position: "bottom"
      },
      // Section SAP
      {
        target: '[data-onboarding="presta-sap-section"]',
        title: "Agrément SAP",
        message: "L'agrément Services à la Personne (SAP) permet à vos clients de bénéficier du crédit d'impôt de 50%. Si vous êtes déclaré auprès de la DREETS, activez cette option.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-sap-switch"]',
        title: "Activation OSP",
        message: "Activez ce switch si vous êtes un Organisme de Services à la Personne agréé/déclaré. Cela vous permettra de renseigner vos informations SAP.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-sap-numero"]',
        title: "Numéro SAP",
        message: "Votre numéro SAP délivré par la DREETS. Il figure sur votre récépissé de déclaration ou arrêté d'agrément.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-sap-date"]',
        title: "Date d'agrément",
        message: "La date à laquelle votre agrément SAP a été délivré. Cette information est vérifiée auprès des autorités.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-sap-document"]',
        title: "Attestation SAP",
        message: "Téléchargez votre attestation d'agrément SAP officielle. Elle sera vérifiée par notre équipe.",
        position: "bottom"
      },
      // Section RGPD
      {
        target: '[data-onboarding="presta-rgpd-section"]',
        title: "Protection des données (RGPD)",
        message: "Cette section concerne le traitement de vos données personnelles. L'acceptation est obligatoire pour utiliser la plateforme.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="presta-rgpd-checkbox"]',
        title: "Consentement RGPD",
        message: "En cochant cette case, vous acceptez les CGU, CGV, la politique de protection des données et la Charte Prestataire. Ces documents vous seront envoyés par email.",
        position: "bottom"
      },
      // Bouton Sauvegarder
      {
        target: '[data-onboarding="presta-save-button"]',
        title: "Sauvegarder vos informations",
        message: "Une fois toutes les informations renseignées, cliquez sur ce bouton pour sauvegarder. Vous serez ensuite redirigé vers la page des compétences pour continuer votre inscription.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/mes-competences",
    exactMatch: true,
    steps: [
      // Introduction
      {
        target: '[data-onboarding="competences-intro"]',
        title: "Bienvenue sur Mes Compétences",
        message: "Cette page vous permet de déclarer toutes vos compétences professionnelles. Plus vos descriptions sont détaillées, plus vous recevrez de missions correspondant à votre expertise.",
        position: "bottom"
      },
      // Introduction IA - NOUVEAU
      {
        target: '[data-onboarding="competences-intro"]',
        title: "🤖 Notre IA au service de votre réussite",
        message: "Contrairement aux autres plateformes, notre système utilise une IA avancée pour analyser, optimiser et classifier automatiquement vos compétences. Résultat : vous êtes mieux mis en valeur et recevez des missions plus pertinentes.",
        position: "bottom"
      },
      // Explication valeur ajoutée IA
      {
        target: '[data-onboarding="competences-intro"]',
        title: "Pourquoi notre système est unique ?",
        message: "1️⃣ Reformulation intelligente : L'IA corrige et enrichit vos descriptions. 2️⃣ Classification sémantique : Vos compétences sont analysées pour un matching précis. 3️⃣ Embeddings vectoriels : Technologie de pointe pour trouver les missions parfaites même si les mots utilisés diffèrent.",
        position: "bottom"
      },
      // Compteur de compétences
      {
        target: '[data-onboarding="competences-counter"]',
        title: "Nombre de compétences",
        message: "Ce compteur affiche le nombre de compétences que vous avez enregistrées. Plus vous en avez, plus vous êtes visible sur différents types de missions.",
        position: "bottom"
      },
      // Alerte crédit d'impôt
      {
        target: '[data-onboarding="competences-credit-impot"]',
        title: "Crédit d'impôt 50%",
        message: "Si vous avez des compétences éligibles aux services à la personne (ménage, jardinage, aide à domicile...), cette alerte vous indique si vos clients peuvent bénéficier du crédit d'impôt de 50%. Pensez à vous déclarer comme OSP !",
        position: "bottom"
      },
      // Bloc guidance - replié
      {
        target: '[data-onboarding="competences-guidance"]',
        title: "Guide de rédaction",
        message: "Cliquez ici pour ouvrir le guide complet. Il contient des conseils précieux pour rédiger des descriptions efficaces, des exemples par métier, et les erreurs à éviter.",
        position: "bottom"
      },
      // Bloc Partenaire Certifié
      {
        target: '[data-onboarding="competences-partenaire"]',
        title: "Profil Partenaire Certifié",
        message: "Découvrez l'offre premium qui multiplie par 5 vos chances d'être contacté : badge certifié, visibilité prioritaire, 15 photos par compétence, statistiques détaillées...",
        position: "bottom"
      },
      // Bloc Estimation IA
      {
        target: '[data-onboarding="competences-estimation-ia"]',
        title: "Pack Estimation IA",
        message: "Nouvel outil exclusif : générez des devis professionnels en quelques secondes grâce à l'intelligence artificielle. Gagnez du temps et impressionnez vos clients.",
        position: "bottom"
      },
      // Carte principale des compétences
      {
        target: '[data-onboarding="competences-main-card"]',
        title: "Liste de vos compétences",
        message: "Cette carte affiche toutes vos compétences déclarées. Cliquez sur une ligne du tableau pour voir et modifier les détails.",
        position: "bottom"
      },
      // Bouton ajouter compétence
      {
        target: '[data-onboarding="competences-add-btn"]',
        title: "Ajouter une compétence",
        message: "Cliquez ici pour déclarer une nouvelle compétence. Vous pourrez décrire votre expertise et l'IA vous aidera à l'optimiser.",
        position: "bottom-left"
      },
      // Tableau des compétences
      {
        target: '[data-onboarding="competences-table"]',
        title: "Tableau des compétences",
        message: "Chaque ligne représente une compétence. Vous voyez la catégorie (famille/sous-famille), la description validée et le niveau. Cliquez sur une ligne pour l'éditer.",
        position: "bottom"
      },
      // Bloc détail - Description originale
      {
        target: '[data-onboarding="competence-detail-description"]',
        title: "Étape 1 : Votre description brute",
        message: "Décrivez votre compétence avec vos propres mots, sans vous soucier du style. Soyez précis : années d'expérience, spécialisations, certifications, équipements utilisés... L'IA fera le reste !",
        position: "bottom"
      },
      // Explication technique description
      {
        target: '[data-onboarding="competence-detail-description"]',
        title: "💡 Comment ça marche ?",
        message: "Votre texte est envoyé à notre IA qui comprend le contexte, identifie les mots-clés importants et analyse votre niveau d'expertise. Plus vous donnez de détails, plus l'IA pourra vous valoriser efficacement.",
        position: "bottom"
      },
      // Bloc détail - Reformulation IA
      {
        target: '[data-onboarding="competence-detail-reformulation"]',
        title: "Étape 2 : La magie de l'IA",
        message: "L'IA analyse votre description et génère une version optimisée : vocabulaire professionnel, structure claire, mise en valeur de vos atouts. Ce texte est conçu pour convaincre les clients.",
        position: "bottom"
      },
      // Explication technique reformulation
      {
        target: '[data-onboarding="competence-detail-reformulation"]',
        title: "🧠 Notre IA comprend votre métier",
        message: "Notre modèle a été entraîné sur des milliers de descriptions de métiers. Il sait ce qui attire les clients : termes techniques appropriés, garanties de qualité, mise en avant de l'expérience. Il corrige aussi les fautes d'orthographe.",
        position: "bottom"
      },
      // Avantage compétitif
      {
        target: '[data-onboarding="competence-detail-reformulation"]',
        title: "🚀 Votre avantage compétitif",
        message: "Grâce à cette reformulation, votre profil apparaît plus professionnel que 90% des prestataires. Les clients font confiance aux descriptions claires et bien rédigées. C'est un vrai facteur de différenciation.",
        position: "bottom"
      },
      // Bouton garder description originale
      {
        target: '[data-onboarding="competence-btn-original"]',
        title: "Option 1 : Garder l'original",
        message: "Si vous préférez votre texte (l'IA corrige quand même l'orthographe), cliquez ici. Utile si vous avez un style personnel que vous souhaitez conserver.",
        position: "bottom"
      },
      // Bouton régénérer
      {
        target: '[data-onboarding="competence-btn-regenerate"]',
        title: "Option 2 : Nouvelle version",
        message: "Pas satisfait de la reformulation ? Cliquez ici pour que l'IA propose une version alternative. Chaque génération est différente grâce à notre algorithme créatif.",
        position: "bottom"
      },
      // Bouton garder reformulation
      {
        target: '[data-onboarding="competence-btn-reformulation"]',
        title: "Option 3 : Valider l'IA ⭐",
        message: "Recommandé ! En validant la reformulation IA, vous bénéficiez d'une description professionnelle optimisée pour attirer les clients. 85% des prestataires choisissent cette option.",
        position: "bottom"
      },
      // Description validée
      {
        target: '[data-onboarding="competence-validated"]',
        title: "Étape 3 : Résultat final",
        message: "Votre description finale apparaît ici après validation. C'est exactement ce texte qui sera visible par les clients potentiels dans leur recherche.",
        position: "bottom"
      },
      // Explication embeddings
      {
        target: '[data-onboarding="competence-validated"]',
        title: "🔍 Recherche intelligente",
        message: "Une fois validée, votre compétence est transformée en 'embedding' (représentation mathématique). Cela permet de vous matcher avec des missions même si le client utilise des mots différents des vôtres.",
        position: "bottom"
      },
      // Classification
      {
        target: '[data-onboarding="competence-classification"]',
        title: "Classification automatique par l'IA",
        message: "L'IA classe automatiquement votre compétence dans notre taxonomie de métiers. Cette classification améliore le ciblage : vous recevez des missions vraiment adaptées à votre profil.",
        position: "bottom"
      },
      // Champ Famille
      {
        target: '[data-onboarding="competence-famille"]',
        title: "Famille de métier",
        message: "La catégorie principale détectée par l'IA (ex: Bâtiment, Services à la personne, Informatique...). Vous pouvez la modifier si l'IA s'est trompée.",
        position: "bottom"
      },
      // Champ Sous-famille
      {
        target: '[data-onboarding="competence-sousfamille"]',
        title: "Sous-famille",
        message: "La spécialité au sein de la famille (ex: Plomberie, Électricité, Jardinage...). Affine le ciblage des missions proposées.",
        position: "bottom"
      },
      // Champ Spécialisation
      {
        target: '[data-onboarding="competence-specialisation"]',
        title: "Spécialisation",
        message: "Votre domaine d'expertise précis (ex: Installation sanitaire, Domotique...). Les missions très ciblées arrivent souvent avec de meilleurs tarifs.",
        position: "bottom"
      },
      // Champ Niveau
      {
        target: '[data-onboarding="competence-niveau"]',
        title: "Niveau déclaré",
        message: "L'IA suggère un niveau basé sur votre description. Vous pouvez l'ajuster : Débutant, Intermédiaire, Confirmé ou Expert. Soyez honnête, les avis clients valideront votre expertise.",
        position: "bottom"
      },
      // Alerte métier réglementé
      {
        target: '[data-onboarding="competence-regulated"]',
        title: "⚠️ Métier réglementé détecté",
        message: "L'IA détecte automatiquement si votre compétence concerne un métier réglementé. Elle vous informe des obligations : certifications requises, assurances obligatoires, qualifications Qualibat/RGE...",
        position: "bottom"
      },
      // Section documents
      {
        target: '[data-onboarding="competence-documents"]',
        title: "Documents justificatifs",
        message: "Téléversez vos diplômes, certifications, attestations de formation... Notre IA analyse ces documents pour vérifier leur authenticité et les informations qu'ils contiennent.",
        position: "bottom"
      },
      // Zone upload documents
      {
        target: '[data-onboarding="competence-documents-upload"]',
        title: "Ajouter des documents",
        message: "Glissez-déposez vos fichiers ou cliquez pour sélectionner. Formats acceptés : PDF, images. L'IA extrait automatiquement les informations clés (dates, numéros, émetteur...).",
        position: "bottom"
      },
      // Section photos
      {
        target: '[data-onboarding="competence-photos"]',
        title: "Photos de réalisations",
        message: "Ajoutez des photos de vos travaux pour montrer votre savoir-faire. Les prestataires avec photos reçoivent 3x plus de demandes que ceux sans visuels.",
        position: "bottom"
      },
      // Zone upload photos
      {
        target: '[data-onboarding="competence-photos-upload"]',
        title: "Ajouter des photos",
        message: "Téléversez des photos avant/après, des réalisations terminées... Astuce : les photos en haute qualité avec un bon éclairage convertissent beaucoup mieux.",
        position: "bottom"
      },
      // Bouton suppression compétence
      {
        target: '[data-onboarding="competence-delete"]',
        title: "Supprimer la compétence",
        message: "Cliquez sur l'icône poubelle pour supprimer définitivement cette compétence. Attention : cette action est irréversible et l'historique sera perdu.",
        position: "bottom-left"
      },
      // Récapitulatif IA
      {
        target: '[data-onboarding="competences-intro"]',
        title: "📊 En résumé : l'IA travaille pour vous",
        message: "1. Reformulation professionnelle de vos descriptions. 2. Classification automatique dans notre taxonomie. 3. Matching intelligent avec les demandes clients. 4. Détection des métiers réglementés. 5. Analyse des documents justificatifs.",
        position: "bottom"
      },
      // Bouton sauvegarder global
      {
        target: '[data-onboarding="competences-save-btn"]',
        title: "Sauvegarder et continuer",
        message: "Une fois vos compétences configurées, cliquez ici pour sauvegarder. L'IA génèrera les embeddings et votre profil sera immédiatement visible pour les nouvelles missions.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/mes-contraintes",
    exactMatch: true,
    steps: [
      // Introduction générale
      {
        target: '[data-onboarding="contraintes-intro"]',
        title: "Bienvenue sur Mes Contraintes",
        message: "Cette page vous permet de définir vos conditions de travail. Ces informations sont essentielles pour recevoir des missions adaptées à votre organisation et éviter les mauvaises surprises.",
        position: "bottom"
      },
      // Explication importance
      {
        target: '[data-onboarding="contraintes-intro"]',
        title: "🎯 Pourquoi remplir cette page ?",
        message: "Plus vos contraintes sont précises, plus les missions proposées correspondent à vos attentes. L'IA utilise ces informations pour filtrer les demandes incompatibles et vous faire gagner du temps.",
        position: "bottom"
      },
      // Explication IA et embeddings
      {
        target: '[data-onboarding="contraintes-intro"]',
        title: "🧠 L'IA analyse vos contraintes",
        message: "Vos contraintes sont transformées en embeddings vectoriels. Cela permet un matching sémantique : même si un client utilise des mots différents, l'IA comprend que sa demande correspond à vos critères.",
        position: "bottom"
      },
      // Carte principale
      {
        target: '[data-onboarding="contraintes-card"]',
        title: "Formulaire des contraintes",
        message: "Cette carte contient 7 catégories de contraintes à renseigner. Prenez le temps de détailler chaque section pour optimiser le matching avec les clients.",
        position: "bottom"
      },
      // Contraintes horaires - Label
      {
        target: '[data-onboarding="contraintes-horaires-label"]',
        title: "1️⃣ Contraintes horaires",
        message: "Définissez vos disponibilités temporelles. Cette section est cruciale car elle détermine quand vous pouvez intervenir.",
        position: "bottom"
      },
      // Contraintes horaires - Tooltip
      {
        target: '[data-onboarding="contraintes-horaires-tooltip"]',
        title: "💡 Aide contextuelle",
        message: "Cliquez sur l'icône (?) pour afficher des conseils détaillés et des exemples concrets. Chaque champ dispose de cette aide.",
        position: "bottom"
      },
      // Contraintes horaires - Textarea
      {
        target: '[data-onboarding="contraintes-horaires-input"]',
        title: "Zone de saisie des horaires",
        message: "Décrivez librement vos disponibilités : jours de travail, créneaux horaires, flexibilité pour les urgences, préférences week-end. Exemple : 'Lundi-vendredi 8h-18h, week-ends sur demande, pas de soirées après 20h'.",
        position: "bottom"
      },
      // Explication analyse IA horaires
      {
        target: '[data-onboarding="contraintes-horaires-input"]',
        title: "🤖 Analyse par l'IA",
        message: "L'IA extrait automatiquement les créneaux mentionnés pour les comparer aux demandes des clients. Plus vous êtes précis, plus le filtrage est efficace.",
        position: "bottom"
      },
      // Contraintes localisation - Label
      {
        target: '[data-onboarding="contraintes-localisation-label"]',
        title: "2️⃣ Contraintes de localisation",
        message: "Définissez votre zone d'intervention géographique. Cette information est combinée avec l'adresse de votre profil pour un calcul précis des distances.",
        position: "bottom"
      },
      // Contraintes localisation - Tooltip
      {
        target: '[data-onboarding="contraintes-localisation-tooltip"]',
        title: "💡 Conseils géographiques",
        message: "Indiquez votre rayon d'action, les frais de déplacement éventuels, les zones à éviter, et vos moyens de transport.",
        position: "bottom"
      },
      // Contraintes localisation - Textarea
      {
        target: '[data-onboarding="contraintes-localisation-input"]',
        title: "Zone de saisie localisation",
        message: "Précisez votre rayon d'intervention en km, les frais de déplacement au-delà d'une certaine distance, et les zones difficiles d'accès. Exemple : 'Rayon 30km, frais 0,50€/km au-delà de 15km, éviter centre-ville aux heures de pointe'.",
        position: "bottom"
      },
      // Contraintes équipements - Label
      {
        target: '[data-onboarding="contraintes-equipements-label"]',
        title: "3️⃣ Contraintes d'équipements",
        message: "Listez les outils et équipements dont vous disposez, et ce que le client doit fournir. Important pour éviter les malentendus.",
        position: "bottom"
      },
      // Contraintes équipements - Tooltip
      {
        target: '[data-onboarding="contraintes-equipements-tooltip"]',
        title: "💡 Détails équipements",
        message: "Mentionnez votre outillage, véhicule utilitaire, équipements spécialisés, limitations de poids/taille, et ce que le client doit fournir.",
        position: "bottom"
      },
      // Contraintes équipements - Textarea
      {
        target: '[data-onboarding="contraintes-equipements-input"]',
        title: "Zone de saisie équipements",
        message: "Décrivez votre matériel disponible et vos limitations. Exemple : 'Outillage électrique complet, véhicule utilitaire 5m³, échafaudage jusqu'à 3m. Le client doit fournir les matériaux et consommables'.",
        position: "bottom"
      },
      // Contraintes langues - Label
      {
        target: '[data-onboarding="contraintes-langues-label"]',
        title: "4️⃣ Contraintes linguistiques",
        message: "Indiquez les langues que vous parlez. Utile si vous pouvez intervenir auprès de clients non francophones.",
        position: "bottom"
      },
      // Contraintes langues - Tooltip
      {
        target: '[data-onboarding="contraintes-langues-tooltip"]',
        title: "💡 Compétences linguistiques",
        message: "Précisez vos langues parlées, votre niveau de maîtrise, et votre langue de préférence pour communiquer.",
        position: "bottom"
      },
      // Contraintes langues - Textarea
      {
        target: '[data-onboarding="contraintes-langues-input"]',
        title: "Zone de saisie langues",
        message: "Listez vos langues avec le niveau. Exemple : 'Français (langue maternelle), Anglais (courant - lu, écrit, parlé), Arabe (notions). Je préfère communiquer en français'.",
        position: "bottom"
      },
      // Contraintes mobilité - Label
      {
        target: '[data-onboarding="contraintes-mobilite-label"]',
        title: "5️⃣ Contraintes de mobilité",
        message: "Détaillez vos moyens de transport et votre capacité à déplacer du matériel. Important pour les missions nécessitant du transport.",
        position: "bottom"
      },
      // Contraintes mobilité - Tooltip
      {
        target: '[data-onboarding="contraintes-mobilite-tooltip"]',
        title: "💡 Moyens de transport",
        message: "Indiquez votre véhicule, permis de conduire, capacité de transport, et vos préférences (péage, autoroute...).",
        position: "bottom"
      },
      // Contraintes mobilité - Textarea
      {
        target: '[data-onboarding="contraintes-mobilite-input"]',
        title: "Zone de saisie mobilité",
        message: "Décrivez vos moyens de transport. Exemple : 'Véhicule utilitaire personnel PTAC 3,5T. Permis B et BE. Peut transporter du matériel volumineux. Évite les péages si possible'.",
        position: "bottom"
      },
      // Contraintes clientèle - Label
      {
        target: '[data-onboarding="contraintes-clientele-label"]',
        title: "6️⃣ Type de clientèle préférée",
        message: "Indiquez avec quel type de clients vous préférez travailler. Cela aide l'IA à vous proposer des missions adaptées à votre profil.",
        position: "bottom"
      },
      // Contraintes clientèle - Tooltip
      {
        target: '[data-onboarding="contraintes-clientele-tooltip"]',
        title: "💡 Préférences clientèle",
        message: "Mentionnez si vous préférez les particuliers ou professionnels, les secteurs d'activité, les profils à éviter, la taille de projet idéale.",
        position: "bottom"
      },
      // Contraintes clientèle - Textarea
      {
        target: '[data-onboarding="contraintes-clientele-input"]',
        title: "Zone de saisie clientèle",
        message: "Précisez vos préférences. Exemple : 'Je travaille principalement avec des particuliers et des PME. À l'aise avec les personnes âgées. Évite les gros chantiers industriels'.",
        position: "bottom"
      },
      // Contraintes tarifs - Label
      {
        target: '[data-onboarding="contraintes-tarifs-label"]',
        title: "7️⃣ Contraintes tarifaires",
        message: "Définissez vos conditions tarifaires. Cette section est essentielle pour filtrer les demandes hors budget.",
        position: "bottom"
      },
      // Contraintes tarifs - Tooltip
      {
        target: '[data-onboarding="contraintes-tarifs-tooltip"]',
        title: "💡 Conditions tarifaires",
        message: "Indiquez votre tarif horaire/journalier, minimum d'intervention, modes de paiement, conditions de devis/acompte, et majorations éventuelles.",
        position: "bottom"
      },
      // Contraintes tarifs - Textarea
      {
        target: '[data-onboarding="contraintes-tarifs-input"]',
        title: "Zone de saisie tarifs",
        message: "Précisez vos conditions. Exemple : 'À partir de 45€/h HT. Minimum 2h d'intervention. Devis gratuit sur place. Acompte 30% pour travaux > 500€. Majoration 50% dimanche et jours fériés'.",
        position: "bottom"
      },
      // Explication matching IA tarifs
      {
        target: '[data-onboarding="contraintes-tarifs-input"]',
        title: "💰 Matching budgétaire intelligent",
        message: "L'IA compare automatiquement vos tarifs avec le budget des clients. Vous ne recevez que des missions correspondant à votre grille tarifaire.",
        position: "bottom"
      },
      // Bouton sauvegarder
      {
        target: '[data-onboarding="contraintes-save-btn"]',
        title: "Sauvegarder vos contraintes",
        message: "Cliquez ici pour enregistrer toutes vos contraintes. L'IA génèrera immédiatement les embeddings pour un matching optimal avec les demandes clients.",
        position: "bottom"
      },
      // Explication étape suivante
      {
        target: '[data-onboarding="contraintes-save-btn"]',
        title: "📅 Prochaine étape : Calendrier",
        message: "Après la sauvegarde, vous serez redirigé vers la configuration de votre calendrier pour définir vos disponibilités précises et synchroniser vos agendas externes.",
        position: "bottom"
      },
      // Récapitulatif final
      {
        target: '[data-onboarding="contraintes-card"]',
        title: "✅ Récapitulatif",
        message: "Vos 7 catégories de contraintes forment un profil complet : horaires, localisation, équipements, langues, mobilité, clientèle et tarifs. L'IA les combine pour un matching précis avec les demandes des clients.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/missions",
    exactMatch: true,
    tabDataAttribute: "data-missions-active-tab",
    steps: (activeTab) => {
      if (activeTab === "proposees") {
        return [
          {
            target: '[data-onboarding="missions-tabs"]',
            title: "Onglets Missions",
            message: "Vous êtes sur les missions proposées. Basculez vers 'Acceptées' ou 'Historique'.",
            position: "bottom"
          },
          {
            target: '[data-onboarding="mission-card"]',
            title: "Proposition de mission",
            message: "Consultez les détails et acceptez ou refusez la proposition.",
            position: "bottom"
          }
        ];
      } else if (activeTab === "acceptees") {
        return [
          {
            target: '[data-onboarding="missions-tabs"]',
            title: "Missions acceptées",
            message: "Gérez vos missions en cours. Marquez-les comme terminées quand c'est fait.",
            position: "bottom"
          },
          {
            target: '[data-onboarding="mission-actions"]',
            title: "Actions",
            message: "Contactez le client ou mettez à jour le statut de la mission.",
            position: "bottom"
          }
        ];
      } else {
        return [
          {
            target: '[data-onboarding="missions-tabs"]',
            title: "Historique",
            message: "Consultez l'historique de toutes vos missions passées.",
            position: "bottom"
          }
        ];
      }
    }
  },
  {
    routePattern: "/prestataire/calendrier",
    exactMatch: true,
    steps: [
      // INTRODUCTION
      {
        target: '[data-onboarding="calendrier-intro"]',
        title: "Bienvenue sur Mon Calendrier",
        message: "Cette page vous permet de gérer vos disponibilités et indisponibilités. Votre calendrier est visible par les clients et l'IA pour le matching intelligent des missions.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-intro"]',
        title: "🎯 Pourquoi configurer votre calendrier ?",
        message: "Un calendrier bien renseigné vous évite les sollicitations inadaptées. L'IA vérifie votre disponibilité AVANT de vous proposer une mission, vous gagnez du temps et les clients aussi.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-intro"]',
        title: "👁️ Visibilité client",
        message: "Les clients peuvent consulter votre calendrier (sans détails) pour voir si vous êtes potentiellement disponible. Cela améliore la confiance et réduit les échanges inutiles.",
        position: "bottom"
      },

      // MODE DE CALENDRIER - LE PLUS IMPORTANT
      {
        target: '[data-onboarding="calendrier-mode-card"]',
        title: "1️⃣ Le mode de calendrier",
        message: "C'est le réglage le plus important ! Il détermine votre comportement par défaut : êtes-vous disponible ou indisponible quand rien n'est indiqué ?",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-mode-disponible"]',
        title: "Mode 'Disponible par défaut' ✅",
        message: "Idéal si vous travaillez régulièrement. Vous n'indiquez QUE vos absences (congés, rendez-vous...). Tous les jours sans annotation sont considérés comme disponibles.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-mode-indisponible"]',
        title: "Mode 'Indisponible par défaut' ❌",
        message: "Idéal pour une activité occasionnelle. Vous indiquez uniquement les jours où vous êtes prêt à travailler. Tous les autres jours sont automatiquement bloqués.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-mode-explication"]',
        title: "💡 Quelle option choisir ?",
        message: "Salarié ou activité secondaire → 'Indisponible par défaut'. Indépendant à temps plein → 'Disponible par défaut'. Le mode change automatiquement l'affichage des couleurs.",
        position: "bottom"
      },

      // SYNCHRONISATION CALENDRIERS EXTERNES
      {
        target: '[data-onboarding="calendrier-externe-section"]',
        title: "2️⃣ Calendriers externes",
        message: "Synchronisez vos agendas Google, Apple iCloud, Microsoft Outlook pour éviter les doubles réservations. Les événements importés bloquent automatiquement votre disponibilité.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-externe-section"]',
        title: "Comment synchroniser ?",
        message: "Cliquez pour ouvrir le panneau, collez les URLs iCal de vos calendriers, activez la synchronisation. Les événements seront importés toutes les heures.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-externe-section"]',
        title: "🔒 Confidentialité",
        message: "Seuls les créneaux occupés sont récupérés, pas les détails de vos rendez-vous personnels. Les clients voient juste 'Indisponible', jamais le contenu.",
        position: "bottom"
      },

      // ALERTE CONFLITS IA
      {
        target: '[data-onboarding="calendrier-conflits-ia"]',
        title: "🤖 Alertes intelligentes",
        message: "L'IA analyse votre calendrier et détecte les incohérences : entrées redondantes, conflits de dates, règles contradictoires. Corrigez-les pour un matching optimal.",
        position: "bottom"
      },

      // NAVIGATION CALENDRIER
      {
        target: '[data-onboarding="calendrier-nav-precedent"]',
        title: "Navigation temporelle",
        message: "Utilisez les flèches pour naviguer : jour/semaine/mois/année précédent(e).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-nav-aujourdhui"]',
        title: "Retour à aujourd'hui",
        message: "Cliquez ici pour revenir à la date du jour instantanément.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-nav-suivant"]',
        title: "Aller au suivant",
        message: "Naviguez vers le jour/semaine/mois/année suivant(e).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-date-label"]',
        title: "Période affichée",
        message: "Indique la période actuellement visible selon le mode de vue sélectionné.",
        position: "bottom"
      },

      // MODES DE VUE
      {
        target: '[data-onboarding="calendrier-vue-tabs"]',
        title: "Modes de vue",
        message: "Changez de perspective selon vos besoins : jour (détaillé), semaine (planning), mois (vue d'ensemble), année (vision long terme).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-vue-jour"]',
        title: "Vue Jour",
        message: "Affiche tous les créneaux d'une seule journée. Idéal pour voir les détails horaires précis.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-vue-semaine"]',
        title: "Vue Semaine",
        message: "Vue recommandée pour planifier votre emploi du temps hebdomadaire. Cliquez sur un jour pour passer en vue jour.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-vue-mois"]',
        title: "Vue Mois",
        message: "Affiche 2 mois côte à côte sur grand écran. Parfait pour visualiser vos congés et périodes chargées.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-vue-annee"]',
        title: "Vue Année",
        message: "Vision globale sur 12 mois. Cliquez sur un mois pour zoomer dessus.",
        position: "bottom"
      },

      // BOUTON AJOUTER
      {
        target: '[data-onboarding="calendrier-btn-ajouter"]',
        title: "3️⃣ Ajouter un créneau",
        message: "Cliquez ici pour créer une nouvelle entrée : congés, disponibilité exceptionnelle, horaires récurrents, période bloquée...",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="calendrier-btn-ajouter"]',
        title: "Assistant intelligent",
        message: "L'assistant vous guide avec des modèles prédéfinis (congés, jours off, créneaux spécifiques...) puis l'IA vérifie la cohérence avant de sauvegarder.",
        position: "bottom-left"
      },

      // GRILLE CALENDRIER - COULEURS
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "4️⃣ La grille calendrier",
        message: "Chaque case représente un jour. Les couleurs indiquent votre statut de disponibilité. Cliquez sur une case pour voir les détails ou ajouter une entrée.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "🎨 Code couleur - Disponibilité",
        message: "🟢 Vert/Bleu = Disponibilité explicite. Vous avez indiqué être prêt à travailler ce jour-là.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "🎨 Code couleur - Indisponibilité",
        message: "🔴 Rouge = Indisponibilité. Congés, absences, créneaux bloqués. Aucune mission ne vous sera proposée.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "🎨 Code couleur - Weekend",
        message: "🟠 Orange clair = Week-end (si vous travaillez le WE). Grisé si le réglage 'travaille week-end' est désactivé.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "🎨 Code couleur - Jours fériés",
        message: "Rouge clair avec texte = Jour férié français. Respecté automatiquement si le réglage est activé.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "🎨 Mode indisponible par défaut",
        message: "En mode 'Indisponible par défaut', les jours sans annotation sont grisés ('Non dispo'). Seuls les jours avec entrée verte sont disponibles.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-grille"]',
        title: "📱 Affichage adaptatif",
        message: "Sur mobile, les libellés sont abrégés (I=Indispo, D=Dispo, WE=Weekend, F=Férié). Cliquez pour voir les détails complets.",
        position: "bottom"
      },

      // TABLEAU RÉCAPITULATIF
      {
        target: '[data-onboarding="calendrier-tableau"]',
        title: "5️⃣ Liste des périodes",
        message: "Ce tableau liste TOUTES vos entrées configurées : congés, horaires récurrents, disponibilités exceptionnelles... Visualisez et gérez-les facilement.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-type"]',
        title: "Colonne Type",
        message: "Indique si c'est une disponibilité (vert) ou indisponibilité (rouge). Les badges utilisent le même code couleur que le calendrier.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-titre"]',
        title: "Colonne Titre",
        message: "Le nom de l'entrée (ex: 'Congés été', 'Formation', 'Dispo matin'). Personnalisez-le pour vous y retrouver.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-periode"]',
        title: "Colonne Période",
        message: "Les dates concernées. Pour les récurrences, affiche les jours de la semaine (Lun, Mar, Mer...).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-horaires"]',
        title: "Colonne Horaires",
        message: "Les horaires si définis, ou 'Journée entière' si toute la journée est concernée.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-mode"]',
        title: "Colonne Mode",
        message: "'Récurrent' = se répète chaque semaine. 'Ponctuel' = dates fixes. Les exceptions (dates exclues) sont indiquées.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-tableau-historique"]',
        title: "Toggle Historique",
        message: "Activez pour voir les anciennes entrées (dates passées). Désactivez pour ne voir que les entrées actuelles et futures.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="calendrier-tableau-supprimer"]',
        title: "Supprimer une entrée",
        message: "Cliquez sur l'icône poubelle pour supprimer. Pour les récurrences, vous pouvez supprimer uniquement une date ou toute la série.",
        position: "bottom-left"
      },

      // RÉGLAGES
      {
        target: '[data-onboarding="calendrier-reglages"]',
        title: "6️⃣ Réglages de disponibilité",
        message: "Cliquez pour ouvrir les options avancées. Ces réglages s'appliquent globalement à votre calendrier et au matching IA.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-resume"]',
        title: "Résumé des réglages",
        message: "Affiche vos paramètres actuels en un coup d'œil : délai de préavis, week-end actif/inactif, jours fériés respectés ou non.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-urgent"]',
        title: "Missions urgentes ⚡",
        message: "Activez pour recevoir des missions de dernière minute. Vous pouvez définir une majoration tarifaire pour les urgences.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-preavis"]',
        title: "Délai de préavis",
        message: "Temps minimum entre la sollicitation et l'intervention. Exemple : '24 heures' signifie qu'on ne peut pas vous contacter pour une mission démarrant dans moins de 24h.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-feries"]',
        title: "Jours fériés",
        message: "Si activé, vous ne travaillez pas les jours fériés français (1er janvier, 1er mai, 14 juillet...). Ces jours seront automatiquement bloqués.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-weekend"]',
        title: "Travail le week-end",
        message: "Indiquez si vous êtes disponible le samedi et dimanche. Si désactivé, ces jours seront grisés sur votre calendrier.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-ajouter-feries"]',
        title: "Ajouter les jours fériés",
        message: "Cliquez pour bloquer automatiquement tous les jours fériés de l'année en cours et de l'année suivante.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-reglages-sauvegarder"]',
        title: "Sauvegarder les réglages",
        message: "N'oubliez pas de sauvegarder après avoir modifié les réglages ! Ils s'appliquent immédiatement au matching IA.",
        position: "bottom"
      },

      // VÉRIFICATION DISPONIBILITÉ
      {
        target: '[data-onboarding="calendrier-verifier"]',
        title: "7️⃣ Vérifier ma disponibilité",
        message: "Outil de simulation : testez si vous êtes disponible sur une période donnée AVANT qu'un client ne vous contacte.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-verifier-journee"]',
        title: "Journée entière",
        message: "Activez pour vérifier toute la journée, ou désactivez pour sélectionner des horaires précis.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-verifier-dates"]',
        title: "Sélection des dates",
        message: "Choisissez la date de début et optionnellement une date de fin pour tester une période.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-verifier-btn"]',
        title: "Lancer la vérification",
        message: "Cliquez pour obtenir le résultat. L'IA vérifie toutes vos règles : mode, congés, récurrences, jours fériés, week-end...",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-verifier-resultat"]',
        title: "Résultat de la vérification",
        message: "✅ Vert = Vous êtes disponible. ❌ Rouge = Indisponible, avec les raisons détaillées (congés, jour férié, week-end...).",
        position: "bottom"
      },

      // RÉCAPITULATIF FINAL
      {
        target: '[data-onboarding="calendrier-intro"]',
        title: "✅ Récapitulatif",
        message: "1. Choisissez votre mode (disponible/indisponible). 2. Synchronisez vos agendas. 3. Ajoutez congés et exceptions. 4. Configurez les réglages. 5. Testez avec l'outil de vérification.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="calendrier-intro"]',
        title: "🎯 Impact sur le matching",
        message: "Un calendrier bien configuré = missions pertinentes uniquement. L'IA ne vous proposera jamais une mission quand vous êtes indisponible. Vous gagnez en sérénité !",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/estimation-ia",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="estimation-input"]',
        title: "Description du travail",
        message: "Décrivez le travail à réaliser pour générer une estimation de prix.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="estimation-generate"]',
        title: "Générer l'estimation",
        message: "L'IA analysera votre description et proposera un devis détaillé.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/profil-enrichi",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="profil-photo"]',
        title: "Photo de profil",
        message: "Ajoutez une photo professionnelle pour inspirer confiance.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="profil-description"]',
        title: "Description",
        message: "Rédigez une présentation de vos services et votre expérience.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="profil-portfolio"]',
        title: "Portfolio",
        message: "Ajoutez des photos de vos réalisations pour montrer votre savoir-faire.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/prestataire/support",
    exactMatch: true,
    steps: [
      // ==========================================
      // PARTIE 1 : INTRODUCTION GÉNÉRALE
      // ==========================================
      {
        target: '[data-onboarding="support-intro"]',
        title: "Bienvenue sur le Support",
        message: "Cette page vous permet de contacter notre équipe pour toute question, problème technique ou réclamation. Un bon système de tickets assure un suivi efficace de vos demandes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="support-intro"]',
        title: "💡 Conseil pour une résolution rapide",
        message: "Plus votre description est détaillée et précise, plus notre équipe pourra résoudre votre demande rapidement. N'hésitez pas à joindre des captures d'écran ou documents.",
        position: "bottom"
      },
      // Boutons d'action
      {
        target: '[data-onboarding="support-refresh-btn"]',
        title: "Actualiser la liste",
        message: "Ce bouton permet de rafraîchir la liste de vos tickets pour voir les dernières mises à jour ou réponses de notre équipe.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="support-new-ticket-btn"]',
        title: "Créer un nouveau ticket",
        message: "Cliquez ici pour ouvrir une nouvelle demande de support. Vous serez guidé pour remplir toutes les informations nécessaires.",
        position: "bottom-left"
      },
      // Onglets
      {
        target: '[data-onboarding="support-tabs"]',
        title: "Navigation par onglets",
        message: "Trois onglets vous permettent de naviguer : 'Mes tickets' pour voir toutes vos demandes, 'Nouveau ticket' pour en créer un, et 'Détail' quand vous consultez un ticket spécifique.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="support-tab-tickets"]',
        title: "Onglet 'Mes tickets'",
        message: "Affiche la liste complète de tous vos tickets de support avec leur statut actuel. Le nombre entre parenthèses indique le total de vos demandes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="support-tab-new"]',
        title: "Onglet 'Nouveau ticket'",
        message: "Ouvre le formulaire de création d'une nouvelle demande de support. Remplissez tous les champs avec soin.",
        position: "bottom"
      },

      // ==========================================
      // PARTIE 2 : ONGLET MES TICKETS (ticket-list-*)
      // Le tutoriel va automatiquement switcher vers cet onglet
      // ==========================================
      {
        target: '[data-onboarding="ticket-list-container"]',
        title: "📋 Onglet 'Mes tickets' - Liste de vos demandes",
        message: "Nous allons maintenant explorer l'onglet 'Mes tickets'. Tous vos tickets apparaissent ici avec leurs informations essentielles.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-filters"]',
        title: "Zone de filtres et recherche",
        message: "Utilisez ces outils pour retrouver rapidement un ticket parmi tous les vôtres. Très utile si vous avez beaucoup de demandes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-search"]',
        title: "Barre de recherche",
        message: "Tapez un mot-clé (numéro de ticket, sujet, description...) pour filtrer instantanément vos tickets. La recherche s'effectue sur tous les champs.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-status-filter"]',
        title: "Filtre par statut",
        message: "Filtrez par statut : 'Ouvert' (en cours de traitement), 'En attente' (en attente de votre réponse), 'Clôturé' (résolu). Sélectionnez 'Tous les statuts' pour tout voir.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-priority-filter"]',
        title: "Filtre par priorité",
        message: "Filtrez par priorité : Basse, Normale, Haute ou Urgente. Cela vous aide à vous concentrer sur les demandes les plus importantes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-table"]',
        title: "Tableau des tickets",
        message: "Cliquez sur les en-têtes de colonnes pour trier (N°, Sujet, Statut, Priorité, Date). Cliquez sur une ligne pour voir les détails du ticket.",
        position: "bottom"
      },
      // Codes couleurs des statuts
      {
        target: '[data-onboarding="ticket-list-table"]',
        title: "🟢 Statut : Ouvert",
        message: "Badge vert = Le ticket est ouvert et notre équipe le traite activement. Vous recevrez une notification quand une réponse sera ajoutée.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-table"]',
        title: "🟠 Statut : En attente",
        message: "Badge orange = Nous attendons une action de votre part (informations supplémentaires, confirmation...). Répondez pour relancer le traitement.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-table"]',
        title: "⚫ Statut : Clôturé",
        message: "Badge gris = Le ticket est résolu et fermé. Vous pouvez toujours le consulter pour référence. Si le problème persiste, créez un nouveau ticket.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-list-table"]',
        title: "Niveaux de priorité",
        message: "🔵 Basse = Non urgent. 🔵 Normale = Traitement standard. 🟠 Haute = Traitement prioritaire. 🔴 Urgente = Traitement immédiat (à utiliser avec parcimonie).",
        position: "bottom"
      },

      // ==========================================
      // PARTIE 3 : ONGLET NOUVEAU TICKET (ticket-form-*, ticket-category-*, etc.)
      // Le tutoriel va automatiquement switcher vers cet onglet
      // ==========================================
      {
        target: '[data-onboarding="ticket-form-card"]',
        title: "📝 Onglet 'Nouveau ticket' - Formulaire de création",
        message: "Nous allons maintenant explorer le formulaire de création de ticket. Ce formulaire vous permet de créer une nouvelle demande de support.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-category"]',
        title: "Catégorie du ticket",
        message: "Choisissez la catégorie qui correspond le mieux à votre demande. Cela aide notre équipe à router votre ticket vers le bon service.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-category-select"]',
        title: "Types de catégories disponibles",
        message: "• Technique : bugs, erreurs, problèmes d'affichage\n• Commercial : questions sur les offres, tarifs\n• Réclamation : insatisfaction, litige\n• Mission : problème avec une mission\n• Facturation : questions sur les paiements\n• Autre : tout ce qui ne rentre pas ailleurs",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-subject"]',
        title: "Sujet du ticket",
        message: "Résumez votre demande en une phrase claire et concise. Ce sujet apparaîtra dans la liste de vos tickets pour les identifier rapidement.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-subject-input"]',
        title: "Exemple de bon sujet",
        message: "✅ Bon : 'Impossible de télécharger mon attestation RCP'\n❌ Mauvais : 'Aide' ou 'Ça ne marche pas'\nSoyez précis !",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-description"]',
        title: "Description détaillée",
        message: "C'est le champ le plus important ! Décrivez précisément votre problème ou question. Plus vous donnez de détails, plus vite nous pourrons vous aider.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-description-textarea"]',
        title: "Éléments à inclure dans la description",
        message: "1️⃣ Ce que vous essayez de faire\n2️⃣ Ce qui se passe (ou ne se passe pas)\n3️⃣ Les messages d'erreur exacts\n4️⃣ Les étapes pour reproduire le problème\n5️⃣ Votre navigateur et appareil",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-moderation"]',
        title: "Modération automatique",
        message: "Notre IA reformule automatiquement les messages contenant un langage inapproprié pour maintenir des échanges professionnels. Vous verrez la version originale et reformulée.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-attachments"]',
        title: "Documents joints",
        message: "Ajoutez des fichiers pour illustrer votre demande : captures d'écran, PDF, documents... Les preuves visuelles accélèrent considérablement la résolution.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-add-file-btn"]',
        title: "Ajouter un fichier",
        message: "Cliquez ici pour sélectionner un ou plusieurs fichiers. Formats acceptés : images (JPG, PNG), PDF, documents Word et texte. Taille max par fichier : 10 Mo.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-files-list"]',
        title: "Fichiers sélectionnés",
        message: "Les fichiers ajoutés apparaissent ici sous forme de badges. Cliquez sur la croix (X) pour retirer un fichier avant l'envoi.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-participants"]',
        title: "Participants (optionnel)",
        message: "Vous pouvez inviter d'autres personnes à suivre ce ticket. Elles recevront un email avec un lien sécurisé pour consulter et participer aux échanges.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-add-participant-btn"]',
        title: "Ajouter un participant",
        message: "Cliquez pour ouvrir le formulaire d'ajout. Vous pouvez ajouter un collègue, un client concerné, ou toute personne impliquée dans le problème.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-participants"]',
        title: "Rôles des participants",
        message: "• Observateur : peut lire mais pas répondre\n• Contributeur : peut lire et répondre\n• Partie concernée : directement impliqué dans le problème",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-submit-btn"]',
        title: "Envoyer la demande",
        message: "Une fois tous les champs remplis, cliquez ici pour créer votre ticket. Vous recevrez un email de confirmation avec le numéro du ticket.",
        position: "bottom"
      },

      // ==========================================
      // PARTIE 4 : ONGLET DÉTAIL (ticket-detail-*, ticket-email-*)
      // Ces étapes s'affichent uniquement quand un ticket est sélectionné
      // Le tutoriel switch automatiquement vers cet onglet
      // ==========================================
      {
        target: '[data-onboarding="ticket-detail-header"]',
        title: "📄 Onglet 'Détail' - Consultation du ticket",
        message: "Vous êtes dans l'onglet Détail qui affiche toutes les informations du ticket sélectionné. Explorons chaque élément.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-detail-back-btn"]',
        title: "Retour à la liste",
        message: "Cliquez sur cette flèche pour revenir à la liste de tous vos tickets.",
        position: "bottom-right"
      },
      {
        target: '[data-onboarding="ticket-detail-print-btn"]',
        title: "Imprimer le ticket",
        message: "Génère une version imprimable complète du ticket : description, historique des échanges, documents joints. Utile pour vos archives ou pour partager avec un tiers.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="ticket-detail-priority"]',
        title: "Modifier la priorité",
        message: "En tant que créateur du ticket, vous pouvez modifier sa priorité. Passez en 'Haute' ou 'Urgente' si la situation s'aggrave ou devient bloquante.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="ticket-detail-description"]',
        title: "Description originale",
        message: "Affiche la description que vous avez fournie lors de la création. Un badge 'Message modéré' apparaît si l'IA a reformulé le texte pour des raisons de modération.",
        position: "bottom"
      },
      // Onglets internes du détail
      {
        target: '[data-onboarding="ticket-detail-tabs"]',
        title: "Onglets du ticket",
        message: "Naviguez entre l'Historique des échanges, les Documents joints et les Participants. Le nombre entre parenthèses indique le total de chaque catégorie.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-detail-timeline"]',
        title: "Onglet Historique",
        message: "Affiche chronologiquement tous les échanges : vos messages, réponses du support, changements de statut, documents ajoutés. C'est le fil complet de la conversation.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-detail-documents"]',
        title: "Onglet Documents",
        message: "Liste tous les documents attachés au ticket (images, PDF, etc.). Vous pouvez les télécharger, voir qui les a ajoutés et quand.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-detail-participants"]',
        title: "Onglet Participants",
        message: "Liste toutes les personnes impliquées dans ce ticket avec leurs rôles et permissions. Vous pouvez ajouter de nouveaux participants pour qu'ils suivent les échanges.",
        position: "bottom"
      },
      // Zone de réponse
      {
        target: '[data-onboarding="ticket-email-composer"]',
        title: "Zone de réponse",
        message: "Utilisez cette zone pour répondre au support, ajouter des informations complémentaires ou poser des questions de suivi.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-email-textarea"]',
        title: "Rédiger votre message",
        message: "Tapez votre réponse ici. Soyez clair et précis. Notre équipe recevra une notification dès l'envoi de votre message.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-email-attachments"]',
        title: "Joindre des fichiers",
        message: "Ajoutez des fichiers à votre réponse : captures d'écran supplémentaires, documents demandés par le support, etc. Vous pouvez aussi coller directement une image (Ctrl+V).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="ticket-email-send"]',
        title: "Envoyer la réponse",
        message: "Cliquez pour envoyer votre message. Il sera ajouté à l'historique du ticket et notre équipe sera notifiée immédiatement.",
        position: "bottom"
      },
      // Sidebar informations
      {
        target: '[data-onboarding="ticket-detail-sidebar"]',
        title: "Informations du ticket",
        message: "Cette zone latérale récapitule les métadonnées du ticket : demandeur, dates importantes, catégorie. Consultez-la pour un aperçu rapide des informations clés.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="ticket-detail-requester"]',
        title: "Informations demandeur",
        message: "Vos informations de contact telles qu'enregistrées lors de la création du ticket (nom, email, téléphone).",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="ticket-detail-dates"]',
        title: "Dates importantes",
        message: "Date de création du ticket et, si applicable, date de résolution. Ces informations vous aident à suivre les délais de traitement de votre demande.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="ticket-detail-category"]',
        title: "Catégorie du ticket",
        message: "La catégorie que vous avez sélectionnée lors de la création. Elle ne peut pas être modifiée après création pour garantir un bon routage.",
        position: "bottom-left"
      },

      // ==========================================
      // PARTIE 5 : RÉCAPITULATIF ET FIN
      // ==========================================
      {
        target: '[data-onboarding="support-intro"]',
        title: "📋 Récapitulatif des bonnes pratiques",
        message: "1️⃣ Soyez précis dans vos descriptions\n2️⃣ Joignez des captures d'écran\n3️⃣ Choisissez la bonne catégorie\n4️⃣ Répondez rapidement aux demandes d'infos\n5️⃣ Consultez régulièrement vos tickets",
        position: "bottom"
      },
      {
        target: '[data-onboarding="support-intro"]',
        title: "✅ Vous êtes prêt !",
        message: "Vous connaissez maintenant toutes les fonctionnalités du support. Créez votre premier ticket ou consultez vos demandes existantes. Notre équipe est là pour vous aider !",
        position: "bottom"
      }
    ]
  }
];
